import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, createSlots as _createSlots, createBlock as _createBlock, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition } from "vue"

const _hoisted_1 = {
  class: "relative z-50 w-full",
  "aria-labelledby": "modal-title",
  role: "dialog",
  "aria-modal": "true"
}
const _hoisted_2 = {
  id: "dialog",
  class: "bounce-modal-animation flex min-h-full w-full items-center justify-center p-0 px-4 text-center"
}
const _hoisted_3 = {
  class: "relative w-full max-w-md rounded-lg bg-white shadow-xl flex flex-col",
  style: {"max-height":"80vh"}
}
const _hoisted_4 = { class: "mt-[80px] flex flex-col items-center whitespace-pre-line text-grey px-4 pb-4" }
const _hoisted_5 = {
  key: 0,
  class: "flex items-center justify-center text-xs"
}
const _hoisted_6 = { class: "flex justify-center space-x-2" }
const _hoisted_7 = {
  key: 0,
  class: "text-xs"
}
const _hoisted_8 = {
  key: 1,
  class: "text-xs"
}
const _hoisted_9 = {
  key: 1,
  class: "text-xs"
}
const _hoisted_10 = {
  class: "flex flex-col items-center whitespace-pre-line text-grey overflow-y-auto px-4 pb-6",
  style: {"flex":"1","min-height":"0","max-height":"calc(80vh - 180px)"}
}
const _hoisted_11 = {
  key: 0,
  class: "font-medium mt-3 text-center px-4"
}
const _hoisted_12 = {
  key: 1,
  class: "font-medium mt-3 text-center"
}
const _hoisted_13 = ["innerHTML"]
const _hoisted_14 = { class: "flex sm:px-4 px-8 pb-8 pt-4 space-x-2 mx-auto xs:flex-col" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ButtonComponent = _resolveComponent("ButtonComponent")!

  return (_openBlock(), _createBlock(_Transition, {
    name: "modal",
    duration: 600
  }, {
    default: _withCtx(() => [
      _withDirectives(_createElementVNode("div", _hoisted_1, [
        _cache[6] || (_cache[6] = _createElementVNode("div", { class: "fixed inset-0 bg-gray-400 bg-opacity-75 transition-opacity" }, null, -1)),
        _createElementVNode("div", {
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onClickOutside && _ctx.onClickOutside(...args))),
          class: "fixed inset-0 z-10 overflow-y-hidden"
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _cache[4] || (_cache[4] = _createElementVNode("div", { class: "absolute top-[-80px] left-0 right-0 z-20 flex flex-col items-center justify-center" }, [
                _createElementVNode("svg", {
                  fill: "white",
                  color: "#FFD92F",
                  class: "h-[150px] w-[150px]",
                  stroke: "currentColor",
                  viewBox: "0 0 24 24",
                  xmlns: "http://www.w3.org/2000/svg"
                }, [
                  _createElementVNode("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": "1.5",
                    "fill-rule": "nonzero",
                    color: "#FFD92F",
                    d: "M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                  })
                ])
              ], -1)),
              _createElementVNode("div", _hoisted_4, [
                (_ctx.appName)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.appName), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_6, [
                  (_ctx.platformApp)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.platformApp), 1))
                    : _createCommentVNode("", true),
                  (_ctx.appVersion)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_ctx.appVersion), 1))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.userData)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.userData.phone_number), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_10, [
                (_ctx.description)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_ctx.description), 1))
                  : _createCommentVNode("", true),
                (_ctx.htmlDescription)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                      _createElementVNode("div", {
                        innerHTML: _ctx.htmlDescription,
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('openWa')))
                      }, null, 8, _hoisted_13)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_14, [
                (_ctx.declineButtonText)
                  ? (_openBlock(), _createBlock(_component_ButtonComponent, {
                      key: 0,
                      onClickAction: _cache[1] || (_cache[1] = ($event: any) => {
                  _ctx.$emit('decline');
                  _ctx.$emit('update:modelValue', false);
                }),
                      "full-width": false,
                      height: "10",
                      class: "mt-5 mr-5 sm:m-[auto] sm:mt-5",
                      "input-class": "px-6",
                      rounded: "lg",
                      title: _ctx.declineButtonText,
                      color: "yellowLight"
                    }, _createSlots({ _: 2 }, [
                      (!_ctx.declineButtonText)
                        ? {
                            name: "title",
                            fn: _withCtx(() => [
                              _renderSlot(_ctx.$slots, "decline-title")
                            ]),
                            key: "0"
                          }
                        : undefined
                    ]), 1032, ["title"]))
                  : _createCommentVNode("", true),
                _createVNode(_component_ButtonComponent, {
                  onClickAction: _cache[2] || (_cache[2] = ($event: any) => {
                  _ctx.$emit('confirm');
                  _ctx.$emit('update:modelValue', false);
                }),
                  "full-width": false,
                  height: "10",
                  "input-class": "px-6",
                  class: "mt-5",
                  rounded: "lg",
                  title: _ctx.confirmButtonText
                }, _createSlots({ _: 2 }, [
                  (!_ctx.confirmButtonText)
                    ? {
                        name: "title",
                        fn: _withCtx(() => [
                          _renderSlot(_ctx.$slots, "confirm-title")
                        ]),
                        key: "0"
                      }
                    : undefined
                ]), 1032, ["title"])
              ]),
              _cache[5] || (_cache[5] = _createElementVNode("div", { class: "absolute bottom-[-10px] left-0 right-0 z-[-1] ml-auto mr-auto h-12 w-11/12 rounded-lg bg-[#FFD92F]" }, null, -1))
            ])
          ])
        ])
      ], 512), [
        [_vShow, _ctx.state || _ctx.modelValue]
      ])
    ]),
    _: 3
  }))
}